import { useEffect } from 'react';

export function useOutsideClick(ref: React.MutableRefObject<HTMLElement | null>, handler: () => void): void {
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function handleClickOutside(event: { target: any }): void {
      if (ref.current && !ref.current?.contains(event.target)) {
        handler();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return (): void => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, handler]);
}
